export default function FinalCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-teal-600 rounded-2xl p-8 md:p-16 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-rocket-line text-3xl text-white"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
            Хотите, чтобы менеджеры перестали бояться холодных звонков и начали получать встречи с потенциальными клиентами?
          </h2>
          <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
            Получите индивидуальную программу корпоративного обучения, построенную на реальных звонках вашего отдела продаж.
          </p>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-white text-teal-700 px-10 py-4 rounded-lg text-lg font-bold hover:bg-white/95 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
          >
            Обучить менеджеров холодным звонкам
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}